import React from 'react';
import { ExtraStripIcon } from '@cdl/heartbeat-react';
import { useDispatch, useSelector } from 'react-redux';
import * as layoutActions from '../../layout/actions/layout.actions';
import { showParentHRPlotSelector } from '../../layout/selectors/layout.selectors';
import { ToolButton } from '../../../features/tool/components/ToolButton';

export const Zoom: React.FC = () => {
  const dispatch = useDispatch();
  const changeHRView = () => {
    dispatch(layoutActions.toggle({ key: 'showParentHRPlot' }));
  };
  const isParentHolterView = useSelector(showParentHRPlotSelector);

  return (
    <ToolButton
      label='View Context'
      onClick={changeHRView}
      aria-label='View Context'
      icon={<ExtraStripIcon />}
      isActive={isParentHolterView}
    />
  );
};
